import "./scss/index.scss";
import { REVIEW_AVATARS } from "@temp/core/config";
import dayjs from "dayjs";
import React from "react";
import LazyLoad from "react-lazy-load";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { generateCategoryUrl } from "../../core/utils";
import imgPlaceholder from "../../images/review-placeholder.png";
import { OverlayContext, OverlayTheme, OverlayType } from "../Overlay";
import { RatingStars } from "./RatingStars";
import { commonMessages } from "../../intl.js";
var DESC_LENGHT_CONST = 139;

var showReviewPopup = function showReviewPopup(overlayContext, item, categoryId, categoryName, showGallery) {
  overlayContext.show(OverlayType.reviewItem, OverlayTheme.modal, {
    data: {
      categoryId: categoryId,
      categoryName: categoryName,
      item: item,
      showGallery: showGallery
    }
  });
};

export function ReviewItem(_ref) {
  var item = _ref.item,
      showGallery = _ref.showGallery;
  var intl = useIntl();
  return React.createElement(OverlayContext.Consumer, null, function (overlayContext) {
    return React.createElement("div", {
      className: "review-item"
    }, React.createElement("div", {
      className: "review-item__col"
    }, React.createElement("div", {
      className: "review-item__images"
    }, item.images.length > 0 && React.createElement("button", {
      type: "button",
      className: "review-item__images-item",
      onClick: function onClick() {
        return showGallery(item.images, 0);
      }
    }, React.createElement(LazyLoad, {
      offset: 300
    }, React.createElement("img", {
      src: item.images[0].url,
      alt: item.images[0].alt
    })), item.images.length > 1 && React.createElement("div", {
      className: "image-count"
    }, item.images.length - 1, "+")), item.images.length === 0 && React.createElement(LazyLoad, {
      offset: 300
    }, React.createElement("img", {
      className: "review-item__images-placeholder",
      src: imgPlaceholder,
      alt: "placeholder"
    }))), React.createElement("div", {
      className: "review-item__collection"
    }, React.createElement("span", {
      className: "review-item__collection-title"
    }, intl.formatMessage(commonMessages.collectionCapitalized)), React.createElement(Link, {
      to: "".concat(generateCategoryUrl(item.category.id, item.category.name))
    }, React.createElement("span", {
      className: "review-item__collection-name"
    }, item.category.name)))), React.createElement("div", {
      className: "review-item__col"
    }, React.createElement("div", {
      className: "top"
    }, React.createElement("div", {
      className: "review-item__rate"
    }, React.createElement(RatingStars, {
      rating: item.rating
    })), React.createElement("div", {
      className: "review-item__title"
    }, item.title), React.createElement("div", {
      className: "review-item__description"
    }, item.description.length > DESC_LENGHT_CONST ? React.createElement(React.Fragment, null, React.createElement("div", null, item.description.slice(0, DESC_LENGHT_CONST), "..."), React.createElement("button", {
      className: "review-item__read-more",
      type: "button",
      onClick: function onClick() {
        showReviewPopup(overlayContext, item, item.category.id, item.category.name, showGallery);
      }
    }, intl.formatMessage(commonMessages.ReadMore))) : React.createElement(React.Fragment, null, React.createElement("span", null, item.description)))), React.createElement("div", {
      className: "review-item__extra"
    }, React.createElement("div", {
      className: "review-item__avatar"
    }, React.createElement(LazyLoad, {
      offset: 300
    }, React.createElement("img", {
      src: REVIEW_AVATARS.get(item.avatar),
      alt: "avatar"
    }))), React.createElement("div", {
      className: "review-item__author"
    }, React.createElement("div", {
      className: "review-item__author-name"
    }, item.fullName), React.createElement("div", {
      className: "review-item__author-date"
    }, dayjs(item.createdAt).format("DD MMM YYYY"))))));
  });
}